/**
 * Snowcubes Gift Card Catalog
 *
 * Source of truth for available card designs, font options, and related constants.
 * Loaded before gift-box-customizer-modal.js so the modal can read from
 * window.SnowcubesGiftCatalog.
 *
 * To add a new card design:
 *   1. Add entry to CARD_CATALOG below
 *   2. Upload artwork to Shopify Files or add a theme asset and reference it
 *      with themeAssetUrl(...)
 *   3. Add CSS rules for `.gift-modal__card-front.is-{cardId}` in gift-box-customizer-modal.css
 *   4. Add Figma template mapping in ai/skills/operation-santa/figma-template-mapping.md
 */
(function initGiftCardCatalog(global) {
  'use strict';

  var GEFEN = { name: 'Gefen Benda', url: 'https://www.gefenbd.com' };

  function getCatalogScriptUrl() {
    try {
      var doc = global.document;
      if (!doc) return '';
      var currentScript = doc.currentScript;
      if (currentScript && currentScript.src) return currentScript.src;
      var scripts = doc.scripts || [];
      for (var index = scripts.length - 1; index >= 0; index -= 1) {
        var script = scripts[index];
        if (script && script.src && script.src.indexOf('gift-card-catalog.js') !== -1) {
          return script.src;
        }
      }
    } catch (_) {
      return '';
    }
    return '';
  }

  function themeAssetUrl(filename) {
    var assetUrls = global.SnowcubesGiftAssetUrls || {};
    if (assetUrls[filename]) return assetUrls[filename];

    var scriptUrl = getCatalogScriptUrl();
    if (scriptUrl) {
      try {
        return new URL(filename, scriptUrl).href;
      } catch (_) {
        // Fall through to a CDN-shaped URL so tests and non-browser callers get a URL.
      }
    }
    return 'https://cdn.shopify.com/s/files/1/0580/0647/0774/files/' + filename;
  }

  var CARD_CATALOG = [
    {
      id: 'knicks_2026_the_leap',
      label: 'Knicks',
      imageUrl: themeAssetUrl('gift-note-knicks-the-leap.svg'),
      imageStyle: { maxHeight: '58%', marginTop: '-0.25rem' },
      greetingPresets: ['FOR THE WIN'],
      closingPresets: ['Big Knicks Energy'],
    },
    {
      id: 'valentines_2025_1',
      label: "Valentine's",
      imageUrl: 'https://cdn.shopify.com/s/files/1/0580/0647/0774/files/valentine.png?v=1770571963',
      imageStyle: { maxHeight: '45%' },
      artist: GEFEN,
      greetingPresets: ["Happy Valentine's"],
      closingPresets: ['With love'],
      hidden: true,
    },
    {
      id: 'valentines_2025_xl',
      label: "Valentine's XL",
      imageUrl: 'https://cdn.shopify.com/s/files/1/0580/0647/0774/files/valentine_xl.png?v=1770571963',
      imageStyle: { maxHeight: '50%' },
      artist: GEFEN,
      greetingPresets: ["Happy Valentine's"],
      closingPresets: ['With love'],
      hidden: true,
    },
    {
      id: 'birthday_2025_1',
      label: 'Birthday',
      imageUrl: 'https://cdn.shopify.com/s/files/1/0580/0647/0774/files/birthday.png?v=1770571963',
      imageStyle: { maxHeight: '45%' },
      artist: GEFEN,
      greetingPresets: ['Happy birthday'],
      closingPresets: ['With love'],
    },
    {
      id: 'wedding_2025_1',
      label: 'Wedding',
      imageUrl: 'https://cdn.shopify.com/s/files/1/0580/0647/0774/files/wedding.png?v=1770571963',
      imageStyle: { maxHeight: '45%' },
      artist: GEFEN,
      greetingPresets: ['Congratulations'],
      closingPresets: ['With love'],
    },
    {
      id: 'warm_winter_2025_1',
      label: 'Warm Winter',
      imageUrl: 'https://cdn.shopify.com/s/files/1/0580/0647/0774/files/warm_winter.png',
      imageStyle: { maxHeight: '36%' },
      artist: GEFEN,
      greetingPresets: ['Stay warm'],
      closingPresets: ['Feel better'],
    },
  ];

  var CARD_CATALOG_BY_ID = CARD_CATALOG.reduce(function (acc, card) {
    acc[card.id] = card;
    return acc;
  }, {});

  var CARD_PICKER_CATALOG = CARD_CATALOG.filter(function (card) {
    return !card.hidden;
  });

  var DEFAULT_CARD_ID = CARD_PICKER_CATALOG[0]
    ? CARD_PICKER_CATALOG[0].id
    : (CARD_CATALOG[0] ? CARD_CATALOG[0].id : 'knicks_2026_the_leap');

  var FONT_OPTIONS = [
    { id: 'serif', label: 'Serif', previewClass: 'is-serif' },
    { id: 'modern', label: 'Modern', previewClass: 'is-modern' },
  ];

  var DEFAULT_FONT_ID = FONT_OPTIONS[0] ? FONT_OPTIONS[0].id : 'serif';

  var GREETING_MAX_LENGTH = 30;
  var CLOSING_MAX_LENGTH = 20;

  /**
   * Normalize a font ID from user input or stored config.
   * Handles legacy aliases (script, elegant, classic) and unknown values.
   * @param {*} fontId
   * @returns {string}
   */
  function normalizeFontId(fontId) {
    if (typeof fontId !== 'string') return DEFAULT_FONT_ID;
    var normalized = fontId.trim().toLowerCase();
    if (normalized === 'script' || normalized === 'elegant') return 'serif';
    if (normalized === 'classic') return 'serif';
    var isKnown = FONT_OPTIONS.some(function (font) { return font.id === normalized; });
    return isKnown ? normalized : DEFAULT_FONT_ID;
  }

  // Public API
  var api = {
    CARD_CATALOG: CARD_CATALOG,
    CARD_CATALOG_BY_ID: CARD_CATALOG_BY_ID,
    CARD_PICKER_CATALOG: CARD_PICKER_CATALOG,
    DEFAULT_CARD_ID: DEFAULT_CARD_ID,
    FONT_OPTIONS: FONT_OPTIONS,
    DEFAULT_FONT_ID: DEFAULT_FONT_ID,
    GREETING_MAX_LENGTH: GREETING_MAX_LENGTH,
    CLOSING_MAX_LENGTH: CLOSING_MAX_LENGTH,
    normalizeFontId: normalizeFontId,
  };

  global.SnowcubesGiftCatalog = api;

  // Jest / Node usage
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }
})(typeof window !== 'undefined' ? window : globalThis);
